import { render, staticRenderFns } from "./leftSidebar.vue?vue&type=template&id=df54905a&scoped=true"
import script from "./leftSidebar.vue?vue&type=script&lang=js"
export * from "./leftSidebar.vue?vue&type=script&lang=js"
import style0 from "./leftSidebar.vue?vue&type=style&index=0&id=df54905a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df54905a",
  null
  
)

export default component.exports